import type { ShowcaseLayout } from './types'

/** Profile route for a linked Gutstring username (from showcase). */
export function showcaseProfilePath(username: string): string {
  const normalized = username.trim().replace(/^@/, '').toLowerCase()
  return `/?view=profile&user=${encodeURIComponent(normalized)}`
}

/** Header label for a showcase artist page. */
export function showcaseArtistLabel(
  layout: ShowcaseLayout | null,
  artistSlug?: string,
): string {
  if (layout?.username) {
    return `@${layout.username}`
  }
  if (layout?.artistLabel) {
    return layout.artistLabel
  }
  if (artistSlug) {
    return `@${artistSlug.toUpperCase()}`
  }
  return '@SHOWCASE'
}
